<template>
  <el-form label-width="160px" @submit.native.prevent>
    <div v-show="!isCollapsed">

      <el-form-item label="SEO文章類型@Type">
        <el-select v-model="form[formKey].Type" style="width: 100%;" placeholder="請選擇">
          <el-option label="AdvertiserContentArticle" value="AdvertiserContentArticle"/>
          <el-option label="NewsArticle" value="NewsArticle"/>
          <el-option label="Report" value="Report"/>
          <el-option label="SatiricalArticle" value="SatiricalArticle"/>
          <el-option label="ScholarlyArticle" value="ScholarlyArticle"/>
          <el-option label="SocialMediaPosting" value="SocialMediaPosting"/>
          <el-option label="TechArticle" value="TechArticle"/>
        </el-select>
      </el-form-item>

      <el-form-item label="標題">
        <el-input v-model="form[formKey].Title" @input="$emit('title-changed', form[formKey].Title)"></el-input>
      </el-form-item>

      <el-form-item label="介紹">
        <el-input v-model="form[formKey].Description" type="textarea" autosize></el-input>
      </el-form-item>

      <el-form-item label="封面圖片">
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="left"
          style="height: 180px;"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genCoverImageFileParam())">
          <img
            ref="coverImg"
            v-show="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            @load="e => onImageLoaded(e, genCoverImageFileParam())"
            class="preview"
            :src="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form[formKey].CoverImageURLX1 || form[formKey]['coverObjectURL'])" class="el-icon-upload"></i>
          <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="日期">
        <el-date-picker v-model="form[formKey].Date" class="left" type="date" placeholder="選擇日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="標籤">
        <div class="w-100">
          <el-select style="width: calc(100% - 50px);margin-right: 22px;" filterable v-model="form[formKey].TagIDs" multiple placeholder="請選擇標籤">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in tags"
              :key="'postTag-'+item.ID"
              :label="item['Title'+formKey]"
              :value="item.ID">
            </el-option>
          </el-select>
          <el-button @click="openTagCreatorModal" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        </div>
        <b class="left">常用標籤:</b>
        <ul style="max-height: 32px;overflow: hidden;">
          <li v-for="tag in commonlyUsedTags"
            :key="'commly-used-postTag-'+tag.ID"
            class="tag tag-commonly"
            @click="toggleTag(tag.ID)">
            #{{tag['Title'+formKey]}}
          </li>
        </ul>
      </el-form-item>
    </div>

    <div style="padding-left: 120px;">
      <div v-show="isCollapsed">詳細資訊</div>

      <el-divider>
        <i v-show="!isCollapsed" class="clickable el-icon-arrow-up" @click="isCollapsed=true">收起</i>
        <i v-show="isCollapsed" class="clickable el-icon-arrow-down" @click="isCollapsed=false">展開</i>
      </el-divider>

      <content-editor v-model="form[formKey].contentJsonArr" />
    </div>

    <postTag-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onTagAdded"/>

  </el-form>
</template>

<script>
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
import PostTagEditorModal from '@/data/postTag/view/editor-modal.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
export default {
  mixins: [MixinProcessImageFile],
  components: {
    ContentEditor,
    PostTagEditorModal
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    },
    formKey: {
      default: ''
    }
  },
  data: () => {
    return {
      isCollapsed: false,
      isShowAddeditModal: false
    }
  },
  computed: {
    tags () {
      return this.$store.state.postTag.list
    },
    commonlyUsedTags () {
      return this.$store.state.post.commonlyUsedTagList
    },
    isEdit () {
      return this.$route.name !== 'createPost'
    }
  },
  methods: {
    onTagAdded (tag) {
      this.toggleTag(tag.ID)
    },
    openTagCreatorModal () {
      this.isShowAddeditModal = true
    },
    // tag
    toggleTag (id) {
      let idx = this.form[this.formKey].TagIDs.findIndex(o => o === id)
      if (idx >= 0) {
        this.form[this.formKey].TagIDs.splice(idx, 1)
      } else {
        this.form[this.formKey].TagIDs.push(id)
      }
    },
    // cover image
    genCoverImageFileParam () {
      let requiredSize = { w: 1920, h: 1080 }
      // 當我們上傳圖片後，
      let params = {
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'elupload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'coverImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'coverObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'CoverImageURLX3',
          'CoverImageURLX2',
          'CoverImageURLX1'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          },
          {
            maxWidth: requiredSize.w * 2 / 3,
            maxHeight: requiredSize.h * 2 / 3
          },
          {
            maxWidth: requiredSize.w / 3,
            maxHeight: requiredSize.h / 3
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'coverImageBlob@3x',
          'coverImageBlob@2x',
          'coverImageBlob@1x'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `post/${this.form.ID}/cover-`
            : `post/cover@3x-${this.form[this.formKey].Title}-`,
          this.isEdit
            ? `post/${this.form.ID}/cover-`
            : `post/cover@2x-${this.form[this.formKey].Title}-`,
          this.isEdit
            ? `post/${this.form.ID}/cover-`
            : `post/cove-@1x-${this.form[this.formKey].Title}-`
        ]
      }
      return params
    }
  },
  created () {
    this.form[this.formKey].contentJsonArr = this.form[this.formKey].Contents
      ? JSON.parse(this.form[this.formKey].Contents)
      : []
    this.$set(this.form[this.formKey], 'coverObjectURL', this.form[this.formKey].CoverImageURLX3)
  }
}
</script>

<style>
/* 常用標籤樣式 */
.tag-commonly {
  float: left;
  margin-left: 4px;
  cursor: pointer;
}
</style>
